if (typeof loadeMoreSlider_G === "undefined") {
  globalThis.loadeMoreSlider_G = null;
}

(function () {
  const initSlider = () => {
    const sliders = document.querySelectorAll(".product-card-js");
    const dir = document.querySelector("html").getAttribute("dir");

    let nextEl = ".product-button-group .swiper-button-next";
    let prevEl = ".product-button-group .swiper-button-prev";
    if (dir === "rtl") {
      [nextEl, prevEl] = [prevEl, nextEl];
    }
    sliders.forEach((slider, index) => {
      if (slider?.swiper) return;

      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const speed = slideCount > 30 ? 0 : 800;

      const productSlider = new Swiper(slider, {
        speed: speed,
        /* Native scroll + CSS scroll-snap instead of JS transforms. The drag then runs on
           the compositor rather than the main thread, which is what stops it stuttering
           against jQuery, GSAP/ScrollTrigger and the grid's lazy images. It is the same
           mechanism camillaandmarc.com uses (overflow-x: auto + scroll-snap-type: x
           mandatory), which was the reference Serena gave.

           Side effect, and it matches the design: native scroll containers do not respond
           to MOUSE dragging, so the card no longer drags by mouse on desktop - the hover
           arrows do that. Madrid was already trying for this with the `990:
           { allowTouchMove: false }` key below, which sits outside `breakpoints` and so
           has never taken effect.

           `speed` above is left alone: in cssMode Swiper moves by
           scrollTo({ behavior: 'smooth' }), so the browser owns the easing and the 800
           only ever applied to the arrow buttons. */
        cssMode: true,
        pagination: {
          el: ".product-pagination .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        allowTouchMove: true,
        990: {
          allowTouchMove: false,
        },
      });
    });
  };

  initSlider();
  loadeMoreSlider_G = initSlider;

  document.addEventListener("shopify:section:load", function () {
    initSlider();
  });
})();
